import CryptoJS from 'crypto-js';

const SECRET_KEY = 'rL8vPx9YD7nKc52zAtWBqRE0JX1TuHgf';
const IV = SECRET_KEY.substring(0, 16);

export const encrypt = (data) => {
  
  try {
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(IV),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    return `ENCRYPTED:${encrypted.toString()}`; // ✅ Mantendo o prefixo para identificação
  } catch (error) {
    // console.error('Erro ao criptografar:', error);
    throw new Error('Failed to encrypt data');
  }
};

export const decrypt = (data) => {
  
  try {
    if (typeof data !== "string") {
      return data; // Retorna direto se não estiver criptografado
    }

    // ✅ Remove o prefixo "ENCRYPTED:"
    const ciphertext = data.trim();
    
    // 🔽 DESCRIPTOGRAFANDO 🔽
    const decrypted = CryptoJS.AES.decrypt(
      ciphertext,
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(IV),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );
   
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

    if (!decryptedText) {
      throw new Error("Descriptografia falhou! O resultado é uma string vazia.");
    }

    return decryptedText; // ✅ Agora retorna a string pura descriptografada
  } catch (error) {
    console.error("❌ Erro ao descriptografar:", error);
    throw new Error("Falha na descriptografia");
  }
};